module.exports = __webpack_public_path__ + "assets/img/classroom_4.882bbf64.jpg";